export default __webpack_public_path__ + "static/media/information--airport--g2.81208f16.png";